import React, { Component } from 'react'
import without from 'lodash/without'
import intersection from 'lodash/intersection'

export default class TypesRestrictions extends Component {
  state = {
    checked: intersection(this.props.selected, this.props.values)
  }

  handleChange = event => {
    const { checked } = this.state
    const { value } = event.target.dataset
    if (checked.includes(value)) {
      this.setState({
        checked: without(checked, value)
      })
    } else {
      let { checked } = this.state
      checked = [ ...checked, value ]
      if (checked.length === this.props.values.length) {
        return alert('You must have at least one checked')
      }
      this.setState({
        checked
      })
    }
  }

  getValues() {
    return this.state.checked
  }

  render() {
    const { values } = this.props
    const { checked } = this.state
    return (
      <div className="search-type-restrictions">
        {values.map(value => (
          <div key={value}>
            <label>
              <input
                type="checkbox"
                data-value={value}
                onChange={this.handleChange}
                checked={!checked.includes(value)} />
              {value}
            </label>
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Search/TypesRestrictions.js